import { Host } from '../../../Host';
import { AccountModel } from '../../account/AccountModel';
import { EditorSession } from '../../canvas/EditorSession';
import { MyRoleInfo } from '../../canvas/MyRoleInfo';
import { WidgetManager } from '../../canvas/workspace/widgets/WidgetManager';
import { ActiveObject, resolve } from '../../Container';
import { AssistantButtonWidget } from './AssistantButtonWidget';

export class AssistantMechanics extends ActiveObject {

    @resolve(AccountModel) private account!: AccountModel;
    @resolve(WidgetManager) private widgets!: WidgetManager;
    @resolve(EditorSession) private session!: EditorSession;

    public start() {
        this.burden(
            this.session.observe(MyRoleInfo, () => this.realizeWidget())
        );

        this.realizeWidget();
    }

    private realizeWidget = () => {

        if (!(this.account.plan?.features?.assistant || Host.env !== 'prod')) {
            return;
        }

        if (!this.session.get(MyRoleInfo)?.canParticipate) {
            return;
        }

        const cont = this.widgets.createContainer({
            name: 'assistant',
            position: ['docked', 'bottomRight'],
            style: 'none',
        });

        const button = this.widgets.createInline({
            ui: AssistantButtonWidget,
        });

        cont.add(button);

        this.widgets.add(cont);
    };
}

